import { RadioGroup, RadioGroupProps } from "@mui/material";
import React, { FC } from "react";

interface IRadioGroupProps extends RadioGroupProps {
	"data-testid": string;
	className?: string;
}

const CutomRadio: FC<IRadioGroupProps> = (props) => {
	return <RadioGroup {...props} className={props.className} data-testid={props["data-testid"]} />;
};

export default CutomRadio;
